import React from 'react';

export enum StepSlug {
  Industry = 'industry',
  Role = 'role',
  RecordingOptions = 'recordingoptions',
  RecordingTest1 = 'recordingtest1', // filler for now
  RecordingTest2 = 'recordingpart2', // filler for now, exact steps will be determined later
  RecordingTest3 = 'recordingpart3', // filler for now, exact steps will be determined later
  Features = 'features'
}

export type context = {
  index: number; // Current step in onboarding
  answers: Record<string, unknown>; // Answers to the previous steps
};

export type StepRuntime = {
  next(slug: StepSlug): void;
  saveStep(slug: StepSlug, data: unknown): void;
  clearStep(slug: StepSlug): void;
  restart(): void;
  context: context;
};

// A generic step definition where T is the props needed for the step
export type Step = {
  slug: StepSlug;
  title?: string;
  Component: React.FC<StepRuntime>; // Each component will have access to the runtime and the props
  shouldShow?: (context: context) => boolean; // Whether to show the step based on answers/previous step
};
